import React from "react"
import BlogPosts from '../components/blog-posts'
import PopularArticlesSidebar from '../components/popular-articles-sidebar'
import BlockHowToGuidesDemolition from "../components/how-to-guides-demolition"
import ServicesDemolition from "../components/services-demolition"
import LayoutDemolition from "../components/layout-demolition"
import SidebarForm from "../components/sidebarForm"

const BLOGPAGEDEMOLITION = ({ pageContext }) => 
{ 
    const code = pageContext.code;
    const posts = pageContext.posts;
    const env = pageContext.env;       
    const ziptitle = 'Find the Right Pro. Simply.';

    const populars = pageContext.populars.length > 0 ? pageContext.populars : [];   
    const paginationInfo = pageContext.pagination;

    const seo = 
    {
        url: 'blog',
        env: env,
        code: code,
        page: pageContext.tags ? 'tags' : 'blogs',
        tag: pageContext.tag?.name ? `${pageContext.tag.name} | Hometown Demolition Contractors Blog` : ''
    }

    const getTitle = () =>
    {
        let title = 'Demolition Tips & Advice';

        if(pageContext.tag != undefined)
        {
            if(pageContext.tag.name != undefined) title = pageContext.tag.name
        }

        return title
    }

    return (
        <LayoutDemolition seo={seo} env={env} code={code}  bgcolor={'#f5f5f5'} hidden={true} callToAction={true}>

            <div className="blog">

                <div className="container mb-5">
                    <div className="row">
                        <div className="col-lg-8">
                            <h1 className="main-title">{getTitle()}</h1>
                            <BlogPosts posts={posts} paginationInfo={paginationInfo} site={env.site}/>
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar">

                                <div className="block">
                                    <div className="card mb-5">                                   
                                        <SidebarForm site={env.site} code="demolition" section="blogs"/>
                                    </div>
                                </div>

                                <div className="block">
                                    <ServicesDemolition env={env} />
                                </div>

                                <div className="block">
                                    <BlockHowToGuidesDemolition />
                                </div>


                                <div className="block">
                                    <PopularArticlesSidebar populars={populars}/>
                                </div>                              

                            </div>                            
                        </div>
                    </div>
                </div> 
            
            
            </div> 

        </LayoutDemolition>
    )
};

export default BLOGPAGEDEMOLITION;